import React from 'react';
import "./Content.css";

import One from '../pages/One';
import Two from '../pages/Two';
import Three from '../pages/Three';
import Four from '../pages/Four';
import Five from '../pages/Five';
import Six from '../pages/Six';
import Seven from '../pages/Seven';
import Eight from '../pages/Eight';

const defaultBody = () => <></>;
	
const contentMap = {
	1: One,
	2: Two,
	3: Three,
	4: Four,
	5: Five,
	6: Six,
	7: Seven,
	8: Eight
};

function Content({ point, onGoUp }) {
	const Body = contentMap[point] || defaultBody;

	const handleClick = () => {
		if (onGoUp) {
			onGoUp();
		}
	}

	return (
		<>
			<Body />
			{ contentMap[point]
			?
				<p className="txt-center" style={{display: "flex", justifyContent: "center"}}>
					<button className="btn-circle" onClick={handleClick}>
						<span>Zobrazit mapku</span>
					</button>
				</p>
			: <></>
			}
		</>
	);
}

export default Content;
